import { ActionService } from 'dashboard-services/services';

export default (() => {
  const AI_TRANSFORMER_OUTPUT_GENERATE_PREFIX = "AI_TRANSFORMER_OUTPUT_GENERATE_PREFIX"
  const AI_TRANSFORMER_FILE_UPLOAD_PREFIX = "AI_TRANSFORMER_FILE_UPLOAD_PREFIX"
  const AI_TRANSFORMER_DATA_LAKE_PROCESSING_PREFIX = "AI_TRANSFORMER_DATA_LAKE_PROCESSING_PREFIX"

  const ON_CHANGE = 'ON_CHANGE_AI_TRANSFORMER'
  const onChange = ActionService.makeActionCreator(ON_CHANGE, 'value', 'name')

  const CLEAR = 'CLEAR_AI_TRANSFORMER'
  const clear = ActionService.makeActionCreator(CLEAR)

  return {
    onChange,
    ON_CHANGE,
    clear,
    CLEAR,
    AI_TRANSFORMER_OUTPUT_GENERATE_PREFIX,
    AI_TRANSFORMER_FILE_UPLOAD_PREFIX,
    AI_TRANSFORMER_DATA_LAKE_PROCESSING_PREFIX,
  }
})()